var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "topo hidden-md-and-down" }, [
        _c("img", {
          style: {
            "margin-top": _vm.isIcmBio ? "5px" : "",
            height: _vm.isIcmBio ? "50px" : "60px"
          },
          attrs: { id: "logo", src: _vm.image, alt: "sicarf", name: "logo" },
          on: { click: _vm.goHome }
        }),
        _c("div", { staticClass: "cards" }, [
          _c("div", { staticClass: "card-text" }, [
            _vm._v("Processos cadastrados até o momento"),
            _c("br"),
            _c("div", { staticClass: "card-total" }, [
              _vm._v(_vm._s(_vm.totalProcessos))
            ])
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "topo hidden-md-and-down topo-menu" },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: {
                "default-active": _vm.getRoute,
                mode: "horizontal",
                router: true
              },
              on: { select: _vm.handleSelect }
            },
            [
              _c("el-menu-item", { attrs: { index: "home" } }, [
                _vm._v("O " + _vm._s(_vm.SISTEMA))
              ]),
              _vm.EXIBIR_COMO_BAIXAR
                ? _c("el-menu-item", { attrs: { index: "baixar" } }, [
                    _vm._v("COMO BAIXAR")
                  ])
                : _vm._e(),
              _vm.EXIBIR_COMO_ENVIAR
                ? _c("el-menu-item", { attrs: { index: "enviar" } }, [
                    _vm._v("COMO ENVIAR")
                  ])
                : _vm._e(),
              _c("el-menu-item", { attrs: { index: "central" } }, [
                _vm._v("CENTRAL DO INTERESSADO")
              ]),
              _vm.EXIBIR_CONSULTA.HEADER
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "submenu-externo",
                      attrs: { index: "consulta" }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v("FAÇA SUA CONSULTA")
                      ]),
                      _c(
                        "div",
                        [
                          _vm.EXIBIR_CONSULTA.ACERVO_FUNDIARIO
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuConsultaGeral
                                  },
                                  attrs: { index: "acervoFundiario" }
                                },
                                [_vm._v("ACERVO FUNDIÁRIO")]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.AUTENTICIDADE
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ":
                                      _vm.isMenuConsultaAutenticidade
                                  },
                                  attrs: { index: "autenticidade" }
                                },
                                [_vm._v("AUTENTICIDADE")]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.LEGISLACAO
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuLegislacao
                                  },
                                  attrs: { index: "consultaLegislacao" }
                                },
                                [_vm._v("CONSULTE A LEGISLAÇÃO")]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.PROCESSO
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuConsultaGeral
                                  },
                                  attrs: { index: "geral" }
                                },
                                [_vm._v("CONSULTAR PROCESSO")]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.MAPA
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuConsultaMapa
                                  },
                                  attrs: { index: "mapa" }
                                },
                                [
                                  _vm._v(
                                    "CONSULTE A LOCALIZAÇÃO DA ÁREA (MAPA)"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.PORTARIA_HOMOLOGACAO
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: { "color-menu ": _vm.isMenuPortaria },
                                  attrs: { index: "portariaHomologacao" }
                                },
                                [_vm._v("PORTARIA DE HOMOLOGAÇÃO")]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.TRANSPARENCIA
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuTransparencia
                                  },
                                  attrs: { index: "transparencia" }
                                },
                                [_vm._v("TRANSPARÊNCIA")]
                              )
                            : _vm._e(),
                          _vm.EXIBIR_CONSULTA.PUBLICACAO
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuConsultaPublicacao
                                  },
                                  attrs: { index: "publicacao" }
                                },
                                [_vm._v("PUBLICAÇÃO")]
                              )
                            : _vm._e(),
                          _vm.isPara
                            ? _c(
                                "el-menu-item",
                                {
                                  staticClass: "submenu-color-hover",
                                  class: {
                                    "color-menu ": _vm.isMenuPainelConflitos
                                  },
                                  on: { click: _vm.openPainelConflitos }
                                },
                                [_vm._v("PAINEL DE CONFLITOS")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _c("el-menu-item", { attrs: { index: "informacao" } }, [
                _vm._v("INFORMAÇÃO")
              ]),
              _vm.EXIBIR_MANUAL_USUARIO
                ? _c("el-menu-item", { attrs: { index: "manualUsuario" } }, [
                    _vm._v("MANUAL DO USUÁRIO")
                  ])
                : _vm._e(),
              _vm.isAmapa && _vm.EXIBIR_SIMULAR_VTN
                ? _c("el-menu-item", { attrs: { index: "simularVtn" } }, [
                    _vm._v("SIMULAR VTN")
                  ])
                : _vm._e(),
              _vm.EXIBIR_CONSULTA.FALE_CONOSCO
                ? _c("el-menu-item", { on: { click: _vm.modalFaleConosco } }, [
                    _vm._v("FALE CONOSCO")
                  ])
                : _vm._e(),
              _vm.EXIBIR_CREDENCIADOS
                ? _c(
                    "el-menu-item",
                    { on: { click: _vm.goCadastroCredenciado } },
                    [_vm._v("SEJA UM CREDENCIADO!")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "menu-sandwich hidden-lg-and-up" }, [
        _c("div", { staticClass: "header-sandwich" }, [
          _c("div", { staticClass: "offset" }),
          _c("img", {
            attrs: { src: _vm.image, alt: "sicarf", name: "logo" },
            on: { click: _vm.goHome }
          }),
          _c("div", { staticClass: "structure-icon" }, [
            _c(
              "div",
              { staticClass: "position-icon", on: { click: _vm.abrirMenu } },
              [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
              1
            )
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "container-sandwich",
            class: { "is-active-sandwich": _vm.isActiveSandwich }
          },
          [
            _c("div", { staticClass: "divider" }),
            _c(
              "el-menu",
              {
                staticClass: "el-menu-demo",
                attrs: {
                  "default-active": _vm.getRoute,
                  mode: "vertical",
                  router: true,
                  "menu-trigger": "click"
                },
                on: { select: _vm.handleSelect }
              },
              [
                _c("el-menu-item", { attrs: { index: "home" } }, [
                  _vm._v("O " + _vm._s(_vm.SISTEMA))
                ]),
                _c("el-menu-item", { attrs: { index: "baixar" } }, [
                  _vm._v("COMO BAIXAR")
                ]),
                _c("el-menu-item", { attrs: { index: "enviar" } }, [
                  _vm._v("COMO ENVIAR")
                ]),
                _c("el-menu-item", { attrs: { index: "central" } }, [
                  _vm._v("CENTRAL DO INTERESSADO")
                ]),
                _vm.EXIBIR_CONSULTA.HEADER
                  ? _c(
                      "el-submenu",
                      {
                        staticClass: "submenu-externo",
                        attrs: { index: "consulta" }
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v("FAÇA SUA CONSULTA")
                        ]),
                        _c(
                          "div",
                          [
                            _vm.EXIBIR_CONSULTA.ACERVO_FUNDIARIO
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ": _vm.isMenuConsultaGeral
                                    },
                                    attrs: { index: "acervoFundiario" }
                                  },
                                  [_vm._v("ACERVO FUNDIÁRIO")]
                                )
                              : _vm._e(),
                            _vm.EXIBIR_CONSULTA.AUTENTICIDADE
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ":
                                        _vm.isMenuConsultaAutenticidade
                                    },
                                    attrs: { index: "autenticidade" }
                                  },
                                  [_vm._v("AUTENTICIDADE")]
                                )
                              : _vm._e(),
                            _vm.EXIBIR_CONSULTA.LEGISLACAO
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ": _vm.isMenuLegislacao
                                    },
                                    attrs: { index: "consultaLegislacao" }
                                  },
                                  [_vm._v("CONSULTE A LEGISLAÇÃO")]
                                )
                              : _vm._e(),
                            _vm.EXIBIR_CONSULTA.PROCESSO
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ": _vm.isMenuConsultaGeral
                                    },
                                    attrs: { index: "geral" }
                                  },
                                  [_vm._v("CONSULTAR PROCESSO")]
                                )
                              : _vm._e(),
                            _vm.EXIBIR_CONSULTA.PORTARIA_HOMOLOGACAO
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ": _vm.isMenuPortaria
                                    },
                                    attrs: { index: "portariaHomologacao" }
                                  },
                                  [_vm._v("PORTARIA DE HOMOLOGAÇÃO")]
                                )
                              : _vm._e(),
                            _vm.EXIBIR_CONSULTA.TRANSPARENCIA
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ": _vm.isMenuTransparencia
                                    },
                                    attrs: { index: "transparencia" }
                                  },
                                  [_vm._v("TRANSPARÊNCIA")]
                                )
                              : _vm._e(),
                            _vm.EXIBIR_CONSULTA.PUBLICACAO
                              ? _c(
                                  "el-menu-item",
                                  {
                                    staticClass: "submenu-color-hover",
                                    class: {
                                      "color-menu ":
                                        _vm.isMenuConsultaPublicacao
                                    },
                                    attrs: { index: "painelConflitos" }
                                  },
                                  [_vm._v("PUBLICAÇÃO")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _c("el-menu-item", { attrs: { index: "informacao" } }, [
                  _vm._v("INFORMAÇÃO")
                ]),
                _vm.EXIBIR_MANUAL_USUARIO
                  ? _c("el-menu-item", { attrs: { index: "manualUsuario" } }, [
                      _vm._v("MANUAL DO USUÁRIO")
                    ])
                  : _vm._e(),
                _vm.isAmapa && _vm.EXIBIR_SIMULAR_VTN
                  ? _c("el-menu-item", { attrs: { index: "simularVtn" } }, [
                      _vm._v("SIMULAR VTN")
                    ])
                  : _vm._e(),
                _vm.EXIBIR_CONSULTA.FALE_CONOSCO
                  ? _c(
                      "el-menu-item",
                      { on: { click: _vm.modalFaleConosco } },
                      [_vm._v("FALE CONOSCO")]
                    )
                  : _vm._e(),
                _vm.EXIBIR_CREDENCIADOS
                  ? _c(
                      "el-menu-item",
                      { on: { click: _vm.goCadastroCredenciado } },
                      [_vm._v("SEJA UM CREDENCIADO!")]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.showModal
        ? _c(
            "app-modal",
            {
              staticClass: "modalFaleConosco",
              attrs: {
                titulo: "Fale conosco",
                width: 700,
                bodyStyle: { height: "auto" },
                footerStyle: { display: "flex", justifyContent: "right" },
                responsive: false
              },
              on: { closeModal: _vm.closeModal }
            },
            [
              _c("template", { slot: "body" }, [
                _c("p", [
                  _vm._v(
                    "Quer entrar em contato para tirar dúvidas ou enviar sugestões?"
                  )
                ]),
                _c("br"),
                _c("p", [_vm._v(_vm._s(_vm.modalTexto))])
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancelarButton",
                        on: { click: _vm.closeModal }
                      },
                      [
                        _c("i", { staticClass: "fas fa-times" }),
                        _vm._v(" Cancelar")
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        key: "botao-confirma",
                        attrs: { type: "primary" },
                        on: { click: _vm.goToLogin }
                      },
                      [
                        _c("i", { staticClass: "fas fa-check" }),
                        _vm._v(" Confirmar")
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04a6ec9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a6ec9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/Header.vue
// module id = null
// module chunks = 